import axios, { AxiosResponse } from 'axios'; 
import { UserType } from '../data/User';

const apiClient = axios.create({
    //baseURL: 'http://localhost/Imob.Api/',
    baseURL: 'https://imobapi.logicalexatus.com.br/',
});

// Interceptor para tratar erros de autenticação (401)
apiClient.interceptors.response.use(
  (response) => response, // Retorna a resposta se for bem-sucedida
  (error) => {
    // Verifica se o erro é de autenticação
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      // Limpa os dados do usuário do localStorage
      localStorage.removeItem('user');
      // Redireciona para a tela de login
      window.location.href = '/'; // Ajuste a rota se necessário
    }
    return Promise.reject(error); // Rejeita a promise para que o erro possa ser tratado localmente se necessário
  });

// Define a generic API function
export const apiRequest = async <T>(url: string, method: 'GET' | 'POST' | 'PUT' | 'DELETE', json: boolean, data?: any): Promise<T> => {
  try {

    const localStore = localStorage.getItem('user');
    const user : UserType | null = localStore ? JSON.parse(localStore) : null;

    const contentType = json ? 'application/json' : 'multipart/form-data';

    const headers = 
    { 
        'Content-Type': contentType,
        'Authorization': `Bearer ${user ? user.token : ""}` // Add token if available
    };

    const response: AxiosResponse<T> = await apiClient({
        method,
        url,
        data,
        headers
    });    
    return response.data;
  } catch (error) {
      // O interceptor já tratou o erro 401.
      // Este bloco agora tratará outros erros (ex: 400, 404, 500, erros de rede).
      if (axios.isAxiosError(error)) {
        if(error.response?.status === 550){
          const mensagem = error.response.data.mensagem;          
          
          throw new Error(mensagem || 'Erro ao realizar a requisição.');
        }
        else{
          console.error('Axios error:', error.response?.status, error.response?.data);
          throw new Error(error.response?.data?.message || 'Erro ao realizar a requisição.');
        }
      } 
      else {
          console.error('Unexpected error:', error);
          throw new Error('Ocorreu um erro inesperado.');
      }
  }
}